import React from "react";
import "../../scss/dashboard/publicadas.css";
import { NavLink } from "react-router-dom";
import TemplateFolders from "./Publicadas/TemplateFolders";
import NoFoldersScreen from "./Publicadas/noFoldersScreen";

function Publicadas() {
  return (
    <div className="plantillas__publicadas">
      <div className="plantillas__publicadas--div1">
        <NavLink
          to="/lawyers/templates/create"
          className="crearPlantilla-Button-abogados"
          activeClassName="crearPlantilla-Button-abogados--active"
        >
          <span>Crear Plantilla</span>
        </NavLink>
      </div>
      <TemplateFolders />
      {/* <NoFoldersScreen
        width={"90%"}
        text={"Crea tu primera plantilla y empieza a ganar"}
      /> */}
    </div>
  );
}

export default Publicadas;
